(function () {
    'use strict';

    /**
     * Apply .scrolled class to the body as the page is scrolled down
     */
    function toggleScrolled() {
        const selectBody = document.querySelector('body');
        const selectHeader = document.querySelector('#header');
        if (!selectHeader || !selectBody) return;
        if (
            !selectHeader.classList.contains('scroll-up-sticky') &&
            !selectHeader.classList.contains('sticky-top') &&
            !selectHeader.classList.contains('fixed-top')
        )
            return;
        window.scrollY > 100
            ? selectBody.classList.add('scrolled')
            : selectBody.classList.remove('scrolled');
    }

    document.addEventListener('scroll', toggleScrolled);
    window.addEventListener('load', toggleScrolled);

    /**
     * Mobile nav toggle
     */
    const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');

    function mobileNavToogle() {
        const body = document.querySelector('body');
        if (body) body.classList.toggle('mobile-nav-active');
        if (mobileNavToggleBtn) {
            mobileNavToggleBtn.classList.toggle('bi-list');
            mobileNavToggleBtn.classList.toggle('bi-x');
        }
    }

    if (mobileNavToggleBtn) {
        mobileNavToggleBtn.addEventListener('click', mobileNavToogle);
    }

    /**
     * Hide mobile nav on same-page/hash links
     */
    document.querySelectorAll('#navmenu a').forEach((navmenu) => {
        navmenu.addEventListener('click', () => {
            if (document.querySelector('.mobile-nav-active')) {
                mobileNavToogle();
            }
        });
    });

    /**
     * Toggle mobile nav dropdowns
     */
    document
        .querySelectorAll('.navmenu .toggle-dropdown')
        .forEach((navmenu) => {
            navmenu.addEventListener('click', function (e) {
                e.preventDefault();
                if (this.parentNode) {
                    this.parentNode.classList.toggle('active');
                    if (this.parentNode.nextElementSibling) {
                        this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
                    }
                }
                e.stopImmediatePropagation();
            });
        });

    /**
     * Preloader
     */
    const preloader = document.querySelector('#preloader');
    if (preloader) {
        window.addEventListener('load', () => {
            preloader.remove();
        });
    }

    /**
     * Scroll top button
     */
    let scrollTop = document.querySelector('.scroll-top');

    function toggleScrollTop() {
        if (scrollTop) {
            window.scrollY > 100
                ? scrollTop.classList.add('active')
                : scrollTop.classList.remove('active');
        }
    }

    if (scrollTop) {
        scrollTop.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    window.addEventListener('load', toggleScrollTop);
    document.addEventListener('scroll', toggleScrollTop);

    /**
     * Animation on scroll function and init
     */
    function aosInit() {
        if (typeof AOS !== 'undefined') {
            AOS.init({
                duration: 600,
                easing: 'ease-in-out',
                once: true,
                mirror: false,
            });
        }
    }

    window.addEventListener('load', aosInit);

    /**
     * Init swiper sliders
     */
    function initSwiper() {
        if (typeof Swiper === 'undefined') return;
        document
            .querySelectorAll('.init-swiper')
            .forEach(function (swiperElement) {
                const configEl = swiperElement.querySelector('.swiper-config');
                if (!configEl) return;
                let config = JSON.parse(configEl.innerHTML.trim());

                if (swiperElement.classList.contains('swiper-tab')) {
                    if (typeof initSwiperWithCustomPagination === 'function') {
                        initSwiperWithCustomPagination(swiperElement, config);
                    }
                } else {
                    new Swiper(swiperElement, config);
                }
            });
    }

    window.addEventListener('load', initSwiper);

    /**
     * Init isotope layout and filters
     */
    function initIsotopes() {
        if (typeof Isotope === 'undefined' || typeof imagesLoaded === 'undefined') return;

        document
            .querySelectorAll('.isotope-layout')
            .forEach(function (isotopeItem) {
                let layout = isotopeItem.getAttribute('data-layout') ?? 'masonry';
                let filter = isotopeItem.getAttribute('data-default-filter') ?? '*';
                let sort =
                    isotopeItem.getAttribute('data-sort') ?? 'original-order';

                let initIsotope;
                const container = isotopeItem.querySelector('.isotope-container');
                if (!container) return;

                imagesLoaded(
                    container,
                    function () {
                        initIsotope = new Isotope(
                            container,
                            {
                                itemSelector: '.isotope-item',
                                layoutMode: layout,
                                filter: filter,
                                sortBy: sort,
                            },
                        );
                    },
                );

                isotopeItem
                    .querySelectorAll('.isotope-filters li')
                    .forEach(function (filters) {
                        filters.addEventListener(
                            'click',
                            function () {
                                const activeFilter = isotopeItem.querySelector(
                                    '.isotope-filters .filter-active',
                                );
                                if (activeFilter) {
                                    activeFilter.classList.remove('filter-active');
                                }
                                this.classList.add('filter-active');
                                if (initIsotope) {
                                    initIsotope.arrange({
                                        filter: this.getAttribute('data-filter'),
                                    });
                                }
                                if (typeof aosInit === 'function') {
                                    aosInit();
                                }
                            },
                            false,
                        );
                    });
            });
    }

    window.addEventListener('load', initIsotopes);

    /**
     * Initiate glightbox
     */
    window.addEventListener('load', function () {
        if (typeof GLightbox !== 'undefined') {
            GLightbox({
                selector: '.glightbox',
            });
        }
    });
})();
